import { BaseComponent } from '../BaseComponent';
import { DataClassUtil } from '../../utils/DataClassUtil';
import { BreakpointUtil } from '../../utils/BreakpointUtil';

class NavigationMobile extends BaseComponent {
  constructor(rootElement: HTMLElement) {
    super(rootElement);

    this.rootElement = rootElement;
    this.toggle = document.querySelector('.js-navigation-mobile-button');
    this.currentlyOpenSubmenu = undefined;
    this.targetSubmenu = undefined;
    this.menuItems = rootElement.querySelectorAll('.js-navigation-mobile-item');
    this.backButtons = rootElement.querySelectorAll('.js-navigation-mobile-backbutton');
    this.subMenu = rootElement.querySelector('.js-navigation-mobile-submenu');
    this.open = false;
  }

  private open: boolean;
  private menuItems: NodeListOf<HTMLElement> | null;
  private backButtons: NodeListOf<HTMLElement> | null;
  private currentlyOpenSubmenu: string | undefined;
  private targetSubmenu: string | undefined;
  public toggle: HTMLElement | null;
  private subMenu: HTMLElement | null;

  private handleClick = () => {
    this.open = !this.open;
    this.stateHandler();
  };

  private stateHandler = () => {
    if (this.open) {
      DataClassUtil.add('openClass', this.rootElement);
      DataClassUtil.add('openNavigationMobile', document.body);
      DataClassUtil.add('mobileActive', this.toggle!);
    } else {
      DataClassUtil.remove('openClass', this.rootElement);
      DataClassUtil.remove('openNavigationMobile', document.body);
      DataClassUtil.remove('mobileActive', this.toggle!);
      this.closeSubmenu();
    }
  };

  private handleMenuItem = (e: Event) => {
    e.preventDefault();
    const interactedElement = e.currentTarget as HTMLElement;

    if (interactedElement) {
      this.targetSubmenu = interactedElement.dataset['targetSubmenu'];

      if (!this.targetSubmenu) {
        if (e.type == 'click') {
          //go to link
          const link = interactedElement.getAttribute('href');
          const target = interactedElement.getAttribute('target');

          if (link && (target === '_self' || target === null)) {
            window.location.href = link;
          } else if (link && target === '_blank') {
            window.open(link);
          }
        } else {
          if (this.currentlyOpenSubmenu !== this.targetSubmenu) {
            this.closeSubmenu();
            this.currentlyOpenSubmenu = this.targetSubmenu;
          }
        }
      } else if (this.targetSubmenu) {
        // open submenu after closing other submenu
        this.closeSubmenu();
        this.openSubmenu(interactedElement);
      }
    }
  };

  private closeSubmenu = () => {
    this.subMenu?.classList.remove('navigation-mobile__submenu--open');
    const subMenuToClose = this.subMenu?.querySelector('.js-navigation-mobile__submenu-items.active');
    subMenuToClose?.classList.remove('active');
  }

  private openSubmenu = (interactedElement: HTMLElement) => {
    // Remove unwanted active classes
    this.menuItems?.forEach(item => {
      if (item.classList.contains('active')) {
        item.classList.remove('active');
      }
    })

    interactedElement.classList.add('active');
    this.currentlyOpenSubmenu = this.targetSubmenu;
    this.subMenu?.classList.add('navigation-mobile__submenu--open');
    const subMenuToOpen = this.subMenu?.querySelector(`[data-navigation-parent-item="${this.targetSubmenu}"]`);
    subMenuToOpen?.classList.add('active');
  }

  private handleBackbutton = () => {
    this.currentlyOpenSubmenu = undefined;
    this.closeSubmenu();
  };

  public init() {
    if (this.toggle) {
      this.toggle.addEventListener('click', this.handleClick);
    }

    if (this.menuItems) {
      if (BreakpointUtil.md) {
        this.menuItems.forEach((menuItem) => {
          menuItem.addEventListener('mouseenter', this.handleMenuItem);
        });
      } else {
        this.menuItems.forEach((menuItem) => {
          menuItem.addEventListener('click', this.handleMenuItem);
        });
      }
    }

    if (this.backButtons) {
      this.backButtons.forEach((backButton) => {
        backButton.addEventListener('click', this.handleBackbutton);
      });
    }
  }
}

export default NavigationMobile;
